import gsap from 'gsap/dist/gsap'
import { useLayoutEffect, useRef } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import StrokeText from '~/shared/components/RewardsChest/StrokeText'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '60vw' }]

const AnimationOrbs = ({ noOfKudos = 0 }: { noOfKudos?: number }): React.ReactElement => {
  const orbsRef = useRef(null)
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })

  // Shorter path for mobile since chest is small
  const animationPath = isMobile
    ? 'M19.351,15.046 C21.537,-32.797 37.056,-66.563 3.955,-60.734'
    : 'M19.351,15.046 C21.537,-32.797 30.448,-79.917 -2.656,-74.078'

  useLayoutEffect(() => {
    gsap.set(orbsRef.current, { xPercent: -50, yPercent: -50, transformOrigin: '50% 50%' })
    gsap.to(orbsRef.current, {
      duration: 1,
      motionPath: {
        path: animationPath,
      },
    })

    gsap.to(orbsRef.current, {
      duration: 2,
      delay: 2.2,
      opacity: 0,
    })

    // MotionPathHelper.create(orbsRef.current)
  }, [animationPath])

  return (
    <div
      className="absolute flex top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 min-w-max"
      ref={orbsRef}
    >
      {noOfKudos > 1 && (
        <StrokeText className="leading-10" fontSize={isMobile ? 20 : 30}>
          {noOfKudos}X
        </StrokeText>
      )}
      <ResponsiveImage mediaQuery={mediaQuery} srcKey="bootcamp/kudos-orb.png" width={40} />
    </div>
  )
}

export default AnimationOrbs
